import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, createContext } from 'react';
// "as unknown as API" is used because we really don't need defaultValue
export const APIContext = createContext(undefined);
export function WithAPI(Element) {
    const wrapper = (props) => (_jsx(APIContext.Consumer, { children: (value) => _jsx(Element, { ...props, api: value }) }));
    wrapper.displayName = `WithAPI<${Element.displayName}>`;
    return wrapper;
}
export function useAPI() {
    return useContext(APIContext);
}
